import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component'
import { FooterComponent } from '../../components/footer/footer.component'
import { HeaderComponent } from '../../components/header/header.component'

@Component({
  selector: 'app-content-layout-bct',
  standalone: true,
  imports: [
    FooterComponent,
    HeaderComponent,
    RouterOutlet,
    BreadcrumbComponent,
  ],
  templateUrl: './content-layout-bct.component.html',
})
export class ContentLayoutBctComponent {
  public constructor() {}
}
